//#region Styles
import {
    Container
} from "./styles";
//#endregion
//#region Components
import Profile from "./components/Profile/Profile";
import LinkUTPHome from "./components/LinkUTPHome/LinkUTPHome";
//#endregion

const Header = ({
    openLogoutOptions
}) => {
    return (
        <Container>
            <LinkUTPHome/>
            <Profile openLogoutOptions={openLogoutOptions}/>
        </Container>
    );
}

export default Header;